import { useRef } from "react";
import { UserTypeCard, type UserTypeCardData } from "./UserTypeCard";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

const USER_TYPES: UserTypeCardData[] = [
  {
    title: "OWNERS AND LANDLORDS",
    description:
      "Real estate investors and developers, portfolio managers, and facilities operations",
  },
  {
    title: "PROJECT MANAGERS",
    description:
      "Real estate investors and developers, portfolio managers, and facilities operations",
  },
  {
    title: "CONSULTANTS AND VENDORS",
    description:
      "Real estate investors and developers, portfolio managers, and facilities operations",
  },
  {
    title: "CONTRACTORS",
    description:
      "Real estate investors and developers, portfolio managers, and facilities operations",
  },
];

export function UserTypes() {
  const sectionRef = useRef<HTMLElement>(null);

  useScrollReveal(sectionRef, { targets: ".item", stagger: 0.12 });

  return (
    <section
      ref={sectionRef}
      id="section-seven"
      className="section section-masthead text-left bg-dark-1"
      data-arts-theme-text="light"
    >
      <div className="flex-column right-menu-padding">
        <div className="seventh-section">
          <div className="items-section">
            {USER_TYPES.map((card) => (
              <UserTypeCard key={card.title} card={card} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
